import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'PageWithGrid.loading',
    defaultMessage: 'Loading'
  }
})
